import { useEffect, useRef, useState } from "react";
import { CopyOutlined, CheckOutlined, LinkOutlined } from "@ant-design/icons";
import { message } from "antd";
import { useParams } from "react-router-dom";
import { MindMapContext } from "../../../Context/contex";
import classes from "./ShareInput.module.css";

const COPIED_FOR_MS = 1800;

/**
 * The shareable link, read-only, with a copy button.
 *
 * The path carries /external only once the map has actually been made public,
 * not when the option is merely selected: the link describes the access that
 * exists, not the access about to be granted.
 */
export const ShareInput = () => {
  const { documentId } = useParams();
  const { isExternalAllow } = MindMapContext();
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef(null);
  const sharedUrl = `https://map.workw.com${isExternalAllow ? "/external" : ""}/${documentId}`;

  // The confirmation is a timer, so it is cancelled if the dialog closes first.
  useEffect(() => () => clearTimeout(resetTimer.current), []);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(sharedUrl);
    } catch (error) {
      message.error("Couldn't copy the link");
      return;
    }
    setCopied(true);
    clearTimeout(resetTimer.current);
    resetTimer.current = setTimeout(() => setCopied(false), COPIED_FOR_MS);
  };

  return (
    <div className={classes.linkRow}>
      <LinkOutlined className={classes.linkIcon} />
      <span className={classes.linkText} title={sharedUrl}>{sharedUrl}</span>
      {/* Confirms in place rather than with a toast: the button is where the user is looking. */}
      <button
        type="button"
        className={`${classes.copyBtn} ${copied ? classes.copyBtnDone : ''}`.trim()}
        onClick={copyLink}
        aria-label="Copy link"
      >
        {copied ? <CheckOutlined /> : <CopyOutlined />}
        <span>{copied ? 'Copied' : 'Copy'}</span>
      </button>
    </div>
  );
};
